import { FUNCTIONS, type FunctionDef } from '@upm/domain';
import { TextArea } from '../../ui';
import { useIntake } from '../IntakeContext';
import { ToolRowField } from '../ToolRowField';
import { FormCard, GroupLabel, StepHeader, type ErrorMap } from './common';

const GROUPS = [...new Set(FUNCTIONS.map((f) => f.group))];

export function StepTools({ errors, flagUnanswered }: { errors: ErrorMap; flagUnanswered: boolean }) {
  const { answers: a, tools, state, setToolRow, setAnswers, editable } = useIntake();
  const row = (f: FunctionDef) => (
    <ToolRowField
      key={f.id}
      fn={f}
      options={state.catalog[f.id] ?? []}
      row={tools[f.id]}
      tips={tools[f.id].tips}
      onChange={(r, o) => setToolRow(f.id, r, o)}
      flagUnanswered={flagUnanswered}
      otherError={errors[`tools.${f.id}.other`]}
      disabled={!editable}
    />
  );
  return (
    <div className="flex flex-col gap-6">
      <StepHeader step={2} title="The tools you use today">
        For each job below, pick every tool you use. Spreadsheets, paper and email count too. If yours isn’t listed, choose Other and type it in. If your firm doesn’t do this, choose Not applicable.
      </StepHeader>
      {GROUPS.map((g) => (
        <section key={g} aria-label={g} className="flex flex-col gap-3">
          <GroupLabel>{g}</GroupLabel>
          {FUNCTIONS.filter((f) => f.group === g).map(row)}
        </section>
      ))}
      <section aria-label="Two last questions" className="flex flex-col gap-3">
        <GroupLabel>Two last questions</GroupLabel>
        <FormCard>
        <TextArea
          id="integrations"
          label="Do any of these tools update each other automatically?"
          hint="For example, a signed proposal creating a customer in QuickBooks, or a finished job posting a message in chat. These connections stop working when you switch, so even small ones are worth listing."
          value={a.integrationsText ?? ''}
          onChange={(e) => setAnswers(2, { integrationsText: e.target.value })}
        />
        <TextArea
          id="fallback"
          label="If your main software went down tomorrow, what spreadsheets, lists or paper would you still need?"
          hint="This catches the trackers that never show up on a software list."
          value={a.fallbackText ?? ''}
          onChange={(e) => setAnswers(2, { fallbackText: e.target.value })}
        />
        </FormCard>
      </section>
    </div>
  );
}
